import { useMemo } from "react"
import { Protocol } from "../Models/API/AppTemplateModel"
import {
    APIJobModel,
    isLabelableJob,
    labelable,
    APIJobCountByStatusParams,
    JobStatus
} from "../Models/API/JobModel"
import { FetchState, getValue, hasValue } from "../Models/Client/FetchState"
import { JobCountStateKey } from "../Reducers/API/Job/JobReducer"
import { useAppInstance } from "./useAppInstance"
import { useAppTemplate } from "./useAppTemplate"
import { useJobCountWithFilters } from "./useJobCountWithFilters"

/**
 * ### Can we laaaabeellllll??????
 *
 * - any role can label :D
 * - any protocol can be labeled :O
 * - the instance mode is crowd = false 8{D
 *
 * things get interesting now...
 *  - if the job(s) has mode "enqueued"** (appears as "queued" in UI)
 *      - can't be labeled... yet.
 *  - if the job is "scheduled" (appears as "queued" in UI ;D )
 *      - can be labeled if is public AND websocket
 *      - can't be labeled if not the above condition
 *  - if the job is in progress
 *      - can be labeled
 *
 *
 * **enqueued is qumes-only, or websocket-private (which
 * appears as "qumes" to the front end)
 *
 * canLabel is true only if couldLabel is true and there are labelable jobs
 *
 * @returns [canLabel, labelableJob, couldLabel]
 */
export function useCanLabelWebSocket(
    appID: string,
    params: APIJobCountByStatusParams,
    stateKey: JobCountStateKey,
    jobListFetch: FetchState<{
        items: APIJobModel[]
        total: number
    }>,
    targetJobs?: APIJobModel[]
): [boolean, APIJobModel[], boolean] {
    const instanceFetch = useAppInstance(appID)

    const templateFetch = useAppTemplate(appID)

    const isCrowd = useMemo(
        () => getValue(instanceFetch)?.canoticCrowd,
        [instanceFetch]
    )

    const count = useJobCountWithFilters(appID, params, stateKey)

    const jobs = useMemo(
        () => (hasValue(jobListFetch) ? jobListFetch.value.items : []),
        [jobListFetch]
    )

    const [canLabel, labelableJobs, couldLabel] = useMemo(() => {
        if (!hasValue(instanceFetch) || !hasValue(templateFetch))
            return [false, [], false]

        const { protocol } = templateFetch.value

        // REMARK: the label selected/filtered/all action is disabled for QUMES for now
        // until it is redesigned
        if (protocol !== Protocol.WEBSOCKET) return [false, [], false]

        const _labelableJobs = (targetJobs ? targetJobs : jobs).filter(
            isLabelableJob
        )

        const _trueCount = labelable().reduce((c, s) => {
            if (s === JobStatus.IN_CREATION) {
                return c
            }
            return c + (count?.[s] ?? 0)
        }, 0)

        const _couldLabel = isCrowd !== undefined ? !isCrowd : false

        const _canLabel =
            _couldLabel && (_labelableJobs.length > 0 || _trueCount > 0)

        return [_canLabel, _labelableJobs, _couldLabel]
    }, [count, instanceFetch, isCrowd, jobs, targetJobs, templateFetch])

    return [canLabel, labelableJobs, couldLabel]
}
